import React from "react";
import styles from "./mentor_box.module.scss";

export const MentorBox = (props) => {
  const { mentor_image, mentor_logo1, mentor_logo2, mentor_name } = props.data;
  return (
    <div className={styles.mentor}>
      <div className={styles.mentor_border}>
        <div className={styles.mentor_avatar}>
          <div className={styles.mentor_avatar_image}>
            <img src={mentor_image} alt={mentor_name || "mentor"} />
          </div>
          <h2 className={styles.mentor_avatar_name}>{mentor_name || ""}</h2>
        </div>
        <div className={styles.mentor_content}>
          <div>
            <p className={styles.mentor_content_time}>Works at</p>
            <div className={styles.mentor_content__logo}>
              <img src={mentor_logo1} alt="Works at" />
            </div>
          </div>
          <div>
            <p className={styles.mentor_content_time}>From</p>
            <div className={styles.mentor_content__logo}>
              <img src={mentor_logo2} alt="From" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentorBox;
